import { Helmet } from "react-helmet-async";

const Seo = ({ title, description, image, type = "website", url }) => {
  const t = title ? `${title} — Luxsova` : "Luxsova — Curated Luxury Fashion";
  const d =
    description ||
    "Luxsova — handbags, fragrances, jewellery and apparel from the world's most desired houses, delivered with white-glove care.";
  return (
    <Helmet>
      <title>{t}</title>
      <meta name="description" content={d} />
      <meta property="og:title" content={t} />
      <meta property="og:description" content={d} />
      <meta property="og:type" content={type} />
      {url && <meta property="og:url" content={url} />}
      {image && <meta property="og:image" content={image} />}
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
};

export default Seo;
